import axios from 'axios';

const state = {
    Items: {
        data: [],
        total: 0
    },
    Item: null,
    ServiceCategories: null,
    Loadings: {
        list: false,
        detail: false,
        popup: false
    },
    OrderCreateObj: {
        "order_type": null,
        "contract_id": null,
        "service_category_id": null,
        "service_location": null,
        "sla_id": null,
        "order_status": "Issued",
    },
    is_read_only: false
};

const getters = {
    Items: (state) => state.Items,
    Item: (state) => state.Item,
    Loadings: (state) => state.Loadings,
    ServiceCategories: (state) => state.ServiceCategories,
    OrderCreateObj: (state) => state.OrderCreateObj,
    IsReadOnly: (state) => state.is_read_only,
};

const actions = {
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.get(`api/orders`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getItem({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "detail", val: true });
            global.axios.get(`api/orders/${id}`)
                .then(response => {
                    commit('setLoadings', { key: "detail", val: false });
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getServiceCategories({ commit }, id) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/service-categories/search`, {
                    params: {
                        filter: {
                            contract_id: id
                        }
                    }
                })
                .then(response => {
                    commit('setSeviceCategories', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async exportItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/orders/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    createOrder({ commit }, param) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/orders/order-type`, param)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    raiseOrder({ commit }, param) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/orders/raise-order`, param)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItem({ commit }, params) {
        let id = params.id;
        let data = params.data;
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "popup", val: true });
            global.axios.post(`api/orders/${id}`, data)
                .then(response => {
                    commit('setLoadings', { key: "popup", val: false });
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.delete(`api/orders`, {
                    data: {
                        ids: params
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async createOrderRunSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/orders`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async createOrderIssueRegister({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/issue-register/create-order`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updateRemarksOrder({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for (var i = 0; i < params.action.photos.length; i++) {
                let photo = params.action.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
            if (params.data.description == null)
                params.data.description = '';
            if (params.data.attachment_del_ids) {
                formData.append('attachment_del_ids', params.data.attachment_del_ids);
            }
            formData.append('description', params.data.description);
            formData.append('remark_type', params.data.remark_type);
            global.axios(`/api/orders/remarks/${params.order_id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then(response => {
                    commit('updateRemarkOder', response.data.data)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async deleteAttachments({ commit }, params) {
        return new Promise((resolve, reject) => {

            global.axios(`/api/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    commit('deleteAttachments', params);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updatePhotos({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for (var i = 0; i < params.photos.length; i++) {
                let photo = params.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
            if (params.attachment_del_ids) {
                formData.append('attachment_del_ids', params.attachment_del_ids);
            }
            formData.append('description', params.remark.description);
            formData.append('remark_type', params.remark.remark_type);
            commit('setLoadings', { key: "popup", val: true });
            global.axios(`api/orders/remarks/${params.id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then(response => {
                    commit('setLoadings', { key: "popup", val: false });
                    commit('setItemPhotos', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    changeStatus({ commit }, params) {
        return new Promise((resolve, reject) => {
            let id = params.id;
            let formData = new FormData();
            formData.append("status", params.status);
            if (params.order_cancel) {
                for (var i = 0; i < params.order_cancel.files.length; i++) {
                    let photo = params.order_cancel.files[i];
                    formData.append('files[' + i + ']', photo);
                    formData.append('file_titles[' + i + ']', photo.image_file_title || '');
                }
                formData.append("c_remark", params.order_cancel.remark || '');
                formData.append("c_reason_id", params.order_cancel.reason_id);
            }
            global.axios.post(`api/orders/${id}/status`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    updateOrderCancellation({ commit }, params) {
        return new Promise((resolve, reject) => {
            let id = params.id;
            let formData = new FormData();
            let file_exists = [];
            let file_title_exists = [];
            for (var i = 0; i < params.files.length; i++) {
                let photo = params.files[i];
                if (photo.id) {
                    file_exists.push(photo.id)
                    file_title_exists.push(photo.image_file_title || '')
                    if (photo.photo) {
                        formData.append('file_update_exists[' + photo.id + ']', photo.photo);
                    }
                } else {
                    formData.append('files[' + i + ']', photo);
                    formData.append('file_titles[' + i + ']', photo.image_file_title || '');
                }

            }
            formData.append("file_exists", JSON.stringify(file_exists));
            formData.append("file_title_exists", JSON.stringify(file_title_exists));
            formData.append("remark", params.remark);
            formData.append("reason_id", params.reason_id);
            global.axios.post(`api/order-cancel-log/${id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    // Budget
    async getBudgetTab({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "detail", val: true });
            global.axios.get(`api/orders/${id}/budget`)
                .then(response => {
                    commit('setLoadings', { key: "detail", val: false });
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "detail", val: false });
                    reject(error)
                });
        });
    },
    // Budget
    async printWo({ commit }, id) {
        commit('setLoadings', { key: "detail", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`api/orders/${id}/generate-pdf`, {
                method: "GET",
                responseType: 'blob',
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                commit('setLoadings', { key: "detail", val: false });
                resolve(response);
            })
            .catch(error => {
                commit('setLoadings', { key: "detail", val: false });
                reject(error)
            });
        });
    },
};

const mutations = {
    setItems(state, data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
    setItem(state, data) {
        state.Item = data;
    },
    async setItemPhotos(state, data) {
        if(state.Item.remark) state.Item.remark.attachments = await [];
        state.Item.remark = await data.remark;
    },
    setSeviceCategories(state, data) {
        state.ServiceCategories = data;
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    },
    updateRemarkOder(state, data) {
        state.Item = {...state.Item, ...data };
    },
    deleteAttachments(state, data) {
        if (data.action == 'action_taken') {
            state.Item.action_taken.attachments = state.Item.action_taken.attachments.filter(img => !data.ids.includes(img.id))
        } else if (data.action == 'work_finding') {
            state.Item.work_finding.attachments = state.Item.work_finding.attachments.filter(img => !data.ids.includes(img.id))
        } else if (data.action == 'order_service_remark') {
            //state.Item.remark.attachments = state.Item.remark.attachments.filter(img => !data.ids.includes(img.id))
        } else {
            state.Item.attachments = state.Item.attachments.filter(img => !data.ids.includes(img.id))
        }
    },
    setOrderCreateObj(state, data) {
        state.OrderCreateObj = data;
    },
    updateKPIActual(state, data) {
        state.Item.kpi = data;
        state.Item = JSON.parse(JSON.stringify(state.Item));
    },
    setIsReadOnly(state, data) {
        state.is_read_only = data || false
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}